module.exports = __webpack_public_path__ + "img/desk1.fcafcedd.png";